"use client";
import * as React from "react";
const SvgCallFilled = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M15.12 11q-1.65 0-3.14-.5a.9.9 0 0 0-.9.22L9.7 12.47A13.5 13.5 0 0 1 3.57 6.4L5.3 4.92a.9.9 0 0 0 .21-.9 10 10 0 0 1-.5-3.14c0-.48-.4-.88-.88-.88H1.06C.58 0 0 .21 0 .88 0 9.14 6.87 16 15.12 16c.63 0 .88-.56.88-1.05v-3.07c0-.48-.4-.88-.88-.88" }));
export {
  SvgCallFilled as default
};
